import React from 'react'
import type { MarketplaceQuote } from '../../../services/backendService'
import '../styles/BidTable.css'

interface QuoteTableProps {
  quotes: MarketplaceQuote[]
  selectingQuoteId?: string | null
  onSelectQuote: (quoteId: string) => void
}

export const QuoteTable: React.FC<QuoteTableProps> = ({ quotes, selectingQuoteId, onSelectQuote }) => {
  const sortedQuotes = [...quotes].sort((a, b) => a.quoteAmount - b.quoteAmount)

  return (
    <div className="bid-table-container">
      <table className="bid-table">
        <thead>
          <tr>
            <th>Farm Name</th>
            <th>Quote Amount</th>
            <th>Est. Days</th>
            <th>Rating</th>
            <th>Status</th>
            <th>Notes</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {sortedQuotes.map(quote => (
            <tr key={quote.id} className="bid-row">
              <td className="farm-name">
                <div>
                  <strong>{quote.farmName}</strong>
                  <span className="reviews">({quote.farmReviewCount} reviews)</span>
                </div>
              </td>
              <td className="bid-amount">
                <span className="price">${quote.quoteAmount.toFixed(2)}</span>
              </td>
              <td className="est-days">{quote.estimatedDays} days</td>
              <td className="rating">
                <span className="stars">⭐ {quote.farmRating.toFixed(1)}</span>
              </td>
              <td className="bid-status">{quote.status.replace('_', ' ')}</td>
              <td className="notes">{quote.notes}</td>
              <td className="action">
                {quote.status === 'pending' ? (
                  <button
                    className="btn-select"
                    disabled={selectingQuoteId !== null}
                    onClick={() => onSelectQuote(quote.id)}
                  >
                    {selectingQuoteId === quote.id ? 'Selecting...' : 'Select'}
                  </button>
                ) : (
                  <span className="action-text">{quote.status === 'accepted' ? 'Selected' : 'Closed'}</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}